import { render, staticRenderFns } from "./FileDropzone.vue?vue&type=template&id=b7e24d02"
import script from "./FileDropzone.vue?vue&type=script&lang=js"
export * from "./FileDropzone.vue?vue&type=script&lang=js"
import style0 from "./FileDropzone.vue?vue&type=style&index=0&id=b7e24d02&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports